var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vuescroll',{ref:"vuescroll",attrs:{"ops":_vm.vuescrollOptions},on:{"handle-scroll":_vm.handleScroll}},[_c('div',{staticClass:"content",style:(_vm.contentStyle)},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }